import apiClient from './Api';
const PREFIX = '/promobillboards';

const getBillboardDetails = postData =>
  apiClient({
    url: `${PREFIX}/getBillboardDetails`,
    method: 'POST',
    data: postData
  });

const saveTemplate = postData =>
  apiClient({
    url: `${PREFIX}/savetemplate`,
    method: 'POST',
    data: postData
  });

const updateTemplate = postData =>
  apiClient({
    url: `${PREFIX}/updatetemplate`,
    method: 'POST',
    data: postData
  });

const deleteTemplate = postData =>
  apiClient({
    url: `${PREFIX}/deletetemplate`,
    method: 'POST',
    data: postData
  });

const saveBillboardFilter = postData =>
  apiClient({
    url: `${PREFIX}/savebillboardfilter`,
    method: 'POST',
    data: postData
  });

const deleteBillboardFilter = postData =>
  apiClient({
    url: `${PREFIX}/deletebillboardfilter`,
    method: 'POST',
    data: postData
  });

const resetVinBillboardProcess = postData =>
  apiClient({
    url: `${PREFIX}/resetvinbillboardprocess`,
    method: 'POST',
    data: postData
  });

const addBillboard = postData =>
  apiClient({
    url: `${PREFIX}/addbillboard`,
    method: 'POST',
    data: postData
  });

const removeBillboard = postData =>
  apiClient({
    url: `${PREFIX}/removebillboard`,
    method: 'POST',
    data: postData
  });

const getVehicleGallery = postData =>
  apiClient({
    url: `${PREFIX}/getvehiclegallery`,
    method: 'POST',
    data: postData
  });

const getBillboardHistory = postData =>
  apiClient({
    url: `${PREFIX}/getbillboardhistory`,
    method: 'POST',
    data: postData
  });

const saveFilterPriorities = postData =>
  apiClient({
    url: `${PREFIX}/savefilterpriorities`,
    method: 'POST',
    data: postData
  });

const updateFilterName = postData =>
  apiClient({
    url: `${PREFIX}/updatefiltername`,
    method: 'POST',
    data: postData
  });

const promoBillboardsService = {
  getBillboardDetails,
  saveTemplate,
  updateTemplate,
  deleteTemplate,
  saveBillboardFilter,
  deleteBillboardFilter,
  resetVinBillboardProcess,
  addBillboard,
  removeBillboard,
  getVehicleGallery,
  getBillboardHistory,
  saveFilterPriorities,
  updateFilterName
};

export default promoBillboardsService;
